import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import ViewVerifiedChecklist from "./ViewVerifiedChecklist";
import { formatDate, getCurrentDate } from "../../../../common/Validations";

const OperatorChecklistReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [openCheckList, setOpenCheckList] = useState(false);
  const [checklistRecord, setCheckListRecord] = useState([]);
  const handleViewChecklist = (data) => {
    setOpenCheckList(true);
    if (Object.keys(data).length >= 1) {
      Object.keys(data).forEach((item) => {
        setCheckListRecord((pevState) => [...pevState, data[item]]);
      });
    }
  };

  const handleChecklistClose = () => {
    setOpenCheckList(false);
    setCheckListRecord([]);
  };

  const columnsData = [
    {
      name: t("msg_reports.msg_machine_idle_status.reported_date"),
      selector: (row) => row.reportDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {formatDate(row.reportDate)}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.department"),
      selector: (row) => row.deptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.deptCode} - {row.deptName}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.machine"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.machineCode} - {row.machineName}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_operator_checklist.verified"),
      selector: (row) => row.completeVerified,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.completeVerified === true ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.complete")}
            </span>
          ) : row.completeVerified === false ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.Incomplete")}
            </span>
          ) : (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.Incomplete")}
            </span>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_operator_checklist.view_verified_checklist"),
      selector: (row) => row.verifiedCheckListData,
      cell: (row) => (
        <Button
          variant="outline-primary"
          onClick={() => handleViewChecklist(row.verifiedCheckListData)}
        >
          {"View Checklist"}
        </Button>
      ),
      center: true,
      width: "250px",
    },
    /* {
    name: t("msg_reports.msg_operator_checklist.verified_checklist"),
    selector: (row) => row.verifiedCheckListData,
    sortable: true,
    width: "200px",
    cell: (row) => (
      <div>
        <p className="m-0 p-0 pt-1">{row.verifiedCheckListData}</p>
      </div>
    ),
  },*/
    {
      name: t("msg_reports.msg_machine_idle_status.reported_by"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.loginUserId}- {row.loginUserName}
          </p>
        </div>
      ),
    },
  ];

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t(
                "msg_reports.msg_operator_checklist.operator_checklist_reports"
              )}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getCurrentDate()}
              </span>
            </h2>
            <p className="subText">
              {t("msg_reports.msg_operator_checklist.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>

      <div>
        <ReportList
          columnsData={columnsData}
          displayFilter={displayFilter}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.msg_machine_idle_status.machine_idle_status_reports"
          )}
          pageURL={Constants.REPORTS.OPERATORCHECKLIST.list}
          name={Constants.REPORTS.OPERATORCHECKLIST.name}
          selectableRows
        />

        {openCheckList && (
          <ViewVerifiedChecklist
            rowsData={checklistRecord}
            show={openCheckList}
            onHide={handleChecklistClose}
          ></ViewVerifiedChecklist>
        )}
      </div>
    </main>
  );
};

export default OperatorChecklistReports;
